<template>
  <div>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">
          {{ $tc("ai_analytics_servers.message") }}
        </label>
        <v-select
          :value="messageFilter"
          :options="messageOptions"
          class="w-100"
          :multiple="false"
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:messageFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">
          {{ $tc("ai_analytics_servers.server") }}
        </label>
        <v-select
          :value="idServerFilter"
          :options="serverOptions"
          class="w-100"
          :multiple="false"
          :reduce="(val) => val.id"
          label="value"
          @input="(val) => $emit('update:idServerFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">
          {{ $t("alarm.start_date_filter") }}
        </label>
        <flat-pickr
          class="form-control"
          :config="{
            enableTime: true,
            dateFormat: 'Y-m-d H:i:S',
            time_24hr: true,
          }"
          :value="startDateFilter"
          @on-change="(selectedDates, val) => $emit('update:startDateFilter', val)"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">
          {{ $t("alarm.end_date_filter") }}
        </label>
        <flat-pickr
          class="form-control"
          :config="{
            enableTime: true,
            dateFormat: 'Y-m-d H:i:S',
            time_24hr: true,
          }"
          :value="endDateFilter"
          @on-change="(selectedDates, val) => $emit('update:endDateFilter', val)"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol, BFormInput } from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import popperHelper from "@/libs/popper-helper";

export default {
  components: {
    BRow,
    BCol,
    BFormInput,
    vSelect,
    flatPickr,
  },
  props: {
    messageOptions: {
      type: Array,
      default: [],
    },
    messageFilter: {
      type: String,
      default: null,
    },
    idServerFilter: {
      type: [String, Number],
      default: null,
    },
    serverOptions: {
      type: Array,
      default: () => [],
    },
    startDateFilter: {
      type: String,
      default: null,
    },
    endDateFilter: {
      type: String,
      default: null,
    },
  },
  setup() {
    return {
      withPopper: popperHelper.withPopper,
    };
  },
};
</script>
